const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const setPanelOpen = (panel, isOpen) => {
  if (!panel) return;

  panel.getAnimations().forEach((animation) => animation.cancel());
  panel.inert = !isOpen;
  panel.setAttribute('aria-hidden', String(!isOpen));

  if (reduceMotion.matches) {
    panel.style.display = isOpen ? 'block' : 'none';
    return;
  }

  if (isOpen) {
    panel.style.display = 'block';
    const height = panel.scrollHeight;
    const animation = panel.animate(
      [{ height: '0px', opacity: 0 }, { height: `${height}px`, opacity: 1 }],
      { duration: 250, easing: 'ease-out' },
    );

    panel.style.overflow = 'hidden';
    animation.onfinish = () => {
      panel.style.height = '';
      panel.style.overflow = '';
    };
    return;
  }

  const animation = panel.animate(
    [{ height: `${panel.offsetHeight}px`, opacity: 1 }, { height: '0px', opacity: 0 }],
    { duration: 200, easing: 'ease-in' },
  );

  panel.style.overflow = 'hidden';
  animation.onfinish = () => {
    panel.style.display = 'none';
    panel.style.height = '';
    panel.style.overflow = '';
  };
};

const closeBranch = (item) => {
  item.querySelectorAll('.dropdown-toggle.open').forEach((toggle) => {
    toggle.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
  });

  item.querySelectorAll('.dropdown').forEach((panel) => setPanelOpen(panel, false));
};

const initializeDropdowns = () => {
  document.querySelectorAll('.nav .dropdown-toggle').forEach((toggle) => {
    const panel = toggle.nextElementSibling;
    if (!panel?.classList.contains('dropdown')) return;

    toggle.setAttribute('aria-expanded', 'false');
    setPanelOpen(panel, false);

    toggle.addEventListener('click', () => {
      const item = toggle.closest('li');
      const isOpen = toggle.classList.toggle('open');

      toggle.setAttribute('aria-expanded', String(isOpen));
      setPanelOpen(panel, isOpen);

      if (!isOpen) {
        panel.querySelectorAll(':scope > li').forEach(closeBranch);
        return;
      }

      Array.from(item.parentElement.children).forEach((sibling) => {
        if (sibling !== item && sibling.matches('li')) closeBranch(sibling);
      });
    });
  });
};

const initializeMobileNavigation = () => {
  const toggle = document.querySelector('#mobileHamburger');
  const navigation = document.querySelector('#navigation');
  if (!toggle || !navigation) return;

  toggle.setAttribute('aria-expanded', 'false');
  setPanelOpen(navigation, false);

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    const isOpen = toggle.classList.toggle('is-active');

    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Menu');
    setPanelOpen(navigation, isOpen);

    if (isOpen) {
      window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    } else {
      navigation.querySelectorAll(':scope .nav > li').forEach(closeBranch);
    }
  });
};

const initializeDesktopNavigation = () => {
  const toggle = document.querySelector('#desktopHamburger');
  const navigation = document.querySelector('#infoSlideout');
  if (!toggle || !navigation) return;

  toggle.setAttribute('aria-expanded', 'false');
  navigation.inert = true;

  toggle.addEventListener('click', (event) => {
    event.preventDefault();
    const isOpen = toggle.classList.toggle('is-active');

    toggle.setAttribute('aria-expanded', String(isOpen));
    toggle.setAttribute('aria-label', isOpen ? 'Close information menu' : 'Information');
    navigation.classList.toggle('is-active', isOpen);
    navigation.style.width = isOpen ? '20rem' : '';
    navigation.inert = !isOpen;
    navigation.setAttribute('aria-hidden', String(!isOpen));
  });
};

export function initializeGlobalNavigation() {
  initializeDropdowns();
  initializeMobileNavigation();
  initializeDesktopNavigation();
}
